var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidacionVehicularLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.116 15.6364H12.9237C13.8121 15.6364 14.539 14.9 14.539 14V5.81822L4.03097 5.81812C2.81943 5.81812 1.76136 6.4972 1.21213 7.49538C0.662898 8.49356 0.800485 13.9999 0.800485 13.9999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03906 18.0909C4.03906 19.4491 5.12137 20.5454 6.46214 20.5454H7.26983C7.26983 19.6454 7.99675 18.9091 8.88522 18.9091C9.77368 18.9091 10.5006 19.6454 10.5006 20.5454H13.7314C13.7314 19.6454 14.4583 18.9091 15.3468 18.9091C16.2352 18.9091 16.9621 19.6454 16.9621 20.5454H17.7698C19.1106 20.5454 20.1929 19.4491 20.1929 18.0909V15.6363C20.1929 15.6363 19.5286 13.0697 18.8117 11.5454C18.3445 10.5519 17.4306 9.09908 17.4306 9.09908C17.1398 8.5918 16.6068 8.27271 16.0252 8.27271H14.5391V14C14.5391 14.9 13.8121 15.6363 12.9237 15.6363H12.116",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88492 22.1819C9.77707 22.1819 10.5003 21.4493 10.5003 20.5455C10.5003 19.6418 9.77707 18.9092 8.88492 18.9092C7.99276 18.9092 7.26953 19.6418 7.26953 20.5455C7.26953 21.4493 7.99276 22.1819 8.88492 22.1819Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3459 22.1819C16.238 22.1819 16.9612 21.4493 16.9612 20.5455C16.9612 19.6418 16.238 18.9092 15.3459 18.9092C14.4537 18.9092 13.7305 19.6418 13.7305 20.5455C13.7305 21.4493 14.4537 22.1819 15.3459 22.1819Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14L5.9648 16.1613C6.82369 17.1061 8.33592 17.015 9.07527 15.974L19 2",
    stroke: "#00A651",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidacionVehicularLight);
export default __webpack_public_path__ + "static/media/validacion_vehicular_light.a212a9b9b0c387e56ef67bc30564f6cd.svg";
export { ForwardRef as ReactComponent };